'use client'

import * as React from 'react'
import { Check } from 'lucide-react'
import { CaretDownIcon } from '../../components/ui/icons/caret-down'
import { cn } from '../../utils/utils'
import { Button } from './button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './command'
import { Popover, PopoverContent, PopoverTrigger } from './popover'

type ComboboxProps = {
    name: string
    placeholder?: string
    options: any[]
    value: any
    onValueChange: (value: string) => void
}

export function Combobox({ name, placeholder, options, value, onValueChange }: ComboboxProps) {
    const [open, setOpen] = React.useState(false)
    const chevronClasses = cn('transition-transform ease-in-out-200', open ? 'rotate-180' : 'rotate-0')

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between bg-white">
                    {value ? options.find(option => option.value === value)?.label : placeholder || 'Select option...'}
                    {/* <ChevronsUpDown className="opacity-50" /> */}
                    <CaretDownIcon className={chevronClasses} />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0 bg-white">
                <Command>
                    <CommandInput name={name} placeholder={placeholder || 'Type to search...'} className="h-9" />
                    <CommandList>
                        <CommandEmpty>No option found.</CommandEmpty>
                        <CommandGroup>
                            {options.map(option => (
                                <CommandItem
                                    // we want to make the selected item visually different
                                    className={value === option.value ? 'bg-blue20 text-blue50' : ''}
                                    key={option.value}
                                    // @ts-ignore we want to use label as value for searching
                                    value={option.label}
                                    onSelect={currentLabel => {
                                        // since we're overriding the CommandItem.value field with the label (so we search/filter by labels),
                                        // we'll use option.value to compare and set the value.
                                        if (option.value === value) {
                                            onValueChange('')
                                        } else {
                                            onValueChange(option.value)
                                        }

                                        setOpen(false)
                                    }}
                                    // If needing to implement custom searching logic

                                    // npm i fuzzysort
                                    // import fuzzysort from "fuzzysort"
                                    // and then import this as prop:
                                    // filter={(value, search) => {
                                    //   const option = options.find(o => o.value === value)
                                    //   if (!option) return 0
                                    //
                                    //   const label = normalize(option.label)
                                    //   const query = normalize(search)
                                    //
                                    //   // Use fuzzysort to compute a match score
                                    //   const result = fuzzysort.single(query, label)
                                    //
                                    //   // fuzzysort returns null if no match, or an object with a score (lower = better)
                                    //   return result ? 1 / Math.abs(result.score + 1) : 0
                                    // }}
                                >
                                    {option.label}
                                    <Check className={cn('ml-auto', value === option.value ? 'opacity-100' : 'opacity-0')} />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    )
}
